<template>
	<v-app>
		<v-hover
			v-slot:default="{ hover }"
			v-if="loggedIn"
			:close-delay="500"
			:open-delay="500"
		>
			<v-navigation-drawer
				app
				v-if="loggedIn"
				width="300px"
				v-model="drawer"
				id="navigation-drawer"
			>
				<v-app-bar
					flat
					height="70px"
					class="transparent pr-0"
				>
					<v-toolbar-title>
						<v-img
							:src="logoPath"
							height="55px"
							width="165px"
							class="head-logo"
							contain
							@click="$router.push('/')"
						></v-img>
						<v-btn
							v-show="hover"
							icon
							absolute
							top
							right
							class="mr-n3 mt-n1"
							@click="drawer = !drawer"
						>
							<v-icon>keyboard_arrow_left</v-icon>
						</v-btn>
					</v-toolbar-title>
				</v-app-bar>
				<v-divider></v-divider>
				<v-toolbar flat>
					<v-row align="center">
						<v-col cols="10" class="py-6 text-no-wrap text-truncate">
							{{ userName }}
						</v-col>
						<v-col cols="2" class="px-0 text-right">
							<v-menu bottom left>
								<template v-slot:activator="{ on }">
									<v-btn icon v-on="on">
										<v-icon>more_vert</v-icon>
									</v-btn>
								</template>

								<v-list>
									<v-list-item
										v-for="item in userMenu"
										:to="item.path"
										:key="item.path"
									>
										<v-list-item-title>
											{{ item.meta.name }}
										</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						</v-col>
					</v-row>
				</v-toolbar>
				<v-divider></v-divider>
				<v-list dense>
					<template v-for="item in mainMenu">
						<v-list-group
							v-if="item.children"
							v-model="item.model"
							:append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
							:key="'children-' + item.path"
						>
							<template v-slot:activator>
								<v-list-item class="pl-0">
									<v-list-item-action class="mr-3 my-0">
										<v-icon>{{ item.meta.icon }}</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>
											{{ item.meta.name }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
							<v-list-item
								v-for="child in item.children"
								:key="child.path"
								class="pl-5"
								style=""
								:to="item.path + '/' + child.path">
								<v-list-item-action class="mr-3"></v-list-item-action>
								<v-list-item-content>
									<v-list-item-title class="pl-4">
										{{ child.meta.name }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
						<v-list-group
							v-else-if="item.meta.sections"
							v-model="item.model"
							:key="'sections-' + item.path"
							@click="sectionGroupNavigate(item)"
							:append-icon="item.model ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
						>
							<template v-slot:activator>
								<v-list-item class="pl-0">
									<v-list-item-action class="mr-3 my-0">
										<v-icon>{{ item.meta.icon }}</v-icon>
									</v-list-item-action>
									<v-list-item-content>
										<v-list-item-title>
											{{ item.meta.name }}
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
							<v-list-item
								v-for="section in item.meta.sections"
								:key="section.name"
								class="pl-5"
								@click="sectionNavigate(item.path, section.href)">
								<v-list-item-action class="mr-3"></v-list-item-action>
								<v-list-item-content>
									<v-list-item-title class="pl-4">
										{{ section.name }}
									</v-list-item-title>
								</v-list-item-content>
							</v-list-item>
						</v-list-group>
						<v-list-item
							v-else
							:key="item.path"
							:to="item.path"
						>
							<v-list-item-action class="mr-3 my-0">
								<v-icon>{{ item.meta.icon }}</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title>
									{{ item.meta.name }}
								</v-list-item-title>
							</v-list-item-content>
							<v-list-item-action class="grey--text justify-center body-2	my-2">
								{{ item.meta.count > 0 ? item.meta.count : '' }}
							</v-list-item-action>
						</v-list-item>
					</template>
				</v-list>
			</v-navigation-drawer>
		</v-hover>
		<v-content>
			<v-toolbar flat dense v-show="!drawer && loggedIn" class="d-print-none">
				<v-app-bar-nav-icon :value="!drawer" @click.native="drawer = !drawer"></v-app-bar-nav-icon>
			</v-toolbar>

	        <router-view
				id="content"
				@print="print"
			></router-view>
		</v-content>
		<v-dialog
			v-model="dialogLoading.open"
			persistent
			width="500"
		>
			<v-card color="primary" dark>
				<v-card-text class="pa-8">
					<v-progress-linear
						indeterminate
						color="white">
					</v-progress-linear>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogDone.open"
			width="500"
		>
			<v-card color="primary" dark>
				<v-card-text class="px-5 py-1">
					<v-container class="pa-0">
						<v-row justify="center">
							<v-col cols="2" class="text-center">
								<v-icon x-large dark>done</v-icon>
							</v-col>
							<v-col class="pa-2 text-left" :class="dialogDone.messageClass" v-if="dialogDone.message">
								<span class="headline" v-text="dialogDone.message"></span>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="dialogNotify.open"
			max-width="600"
			persistent
		>
    		<v-card>
        		<v-card-title class="headline">
					{{ dialogNotify.title }}
				</v-card-title>

				<v-card-text>
					<span
						v-html="dialogNotify.message"
						class="text--primary">
					</span>
		        </v-card-text>

	        	<v-card-actions class="pa-4">
					<v-btn color="primary" @click="dialogNotifyHide">
	            		Закрыть
	          		</v-btn>
	        	</v-card-actions>
	      	</v-card>
	    </v-dialog>
		<v-dialog
			v-model="dialogConfirm.open"
			max-width="600"
			ref="confirm"
			persistent>
    		<v-card>
        		<v-card-title class="headline">
					{{ dialogConfirm.title }}
				</v-card-title>

		        <v-card-text>
					<span
						v-html="dialogConfirm.message"
						class="text--primary">
					</span>
		        </v-card-text>

	        	<v-card-actions class="pa-4">
					<v-btn color="primary" @click="dialogConfirmAccept">
						{{ dialogConfirm.btnAcceptText }}
					</v-btn>
					<v-btn color="primary" @click.native="dialogConfirmDeny">
						{{ dialogConfirm.btnDenyText }}
					</v-btn>
	        	</v-card-actions>
	      	</v-card>
	    </v-dialog>
	</v-app>
</template>

<style scoped>
	/* локальные стили */
	.head-logo {
		padding-left: -10px;
	}
	.head-logo:hover {
		cursor: pointer;
	}
</style>

<style>
	@page {
		size: A3 landscape;
		margin: 5mm 5mm 5mm 5mm;
	}
	@media print {
		html, body {
			width: 420mm;
			height: 297mm;
		}
	}
</style>

<script>
	export default {
		data: () => ({
			drawer: false,
			toolbar: false,
			mainMenu: null,
			userMenu: null,
		}),
		computed: {
			loggedIn() {
				return this.$store.getters.loggedIn
			},
			logoPath() {
				let date = new Date()
				if (date.getMonth() == 11 && date.getDate() > 15) {
					return 'img/ifk-reports-logo-ny.png'
				}
				else if (date.getMonth() == 0 && date.getDate() < 15) {
					return 'img/ifk-reports-logo-ny.png'
				}
				else {
					return 'img/ifk-reports-logo.png'
				}
			},
			userName() {
				return this.$store.getters.userName || ''
			},
			dialogDone() {
				return this.$store.getters.dialogDone
			},
			dialogLoading() {
				return this.$store.getters.dialogLoading
			},
			dialogNotify() {
				return this.$store.getters.dialogNotify
			},
			dialogConfirm() {
				return this.$store.getters.dialogConfirm
			},
		},
		created() {
			// console.log('App created')
			if (this.loggedIn) {
				this.refreshMenus()

				if (this.$route.meta === undefined
					|| this.$route.meta.count === undefined
				) {
					this.$store.dispatch('loadMenuCounters')
				}
			}
		},
		mounted() {
			// console.log('App mounted')
			this.drawer = this.$vuetify.breakpoint.lgAndUp
		},
		watch: {
			loggedIn(value) {
				// console.log('loggedIn watcher')
				if (value) {
					// console.log('loggedIn == true')
					this.refreshMenus()
				}
			}
		},
		methods: {
			refreshMenus () {
				// console.log('refreshMenus')
				// console.log('Help sections')
				// console.log(this.$router.options.routes[17].meta.sections)

				this.mainMenu = this.$router.options.routes.map(route => {

					// console.log('')
					// console.log('')
					// console.log('route', route.name)
					// console.log(typeof route)
					// console.log(route)

					if (!route.meta.mainMenu) return null
					else {

						let youMayPass = route.meta.requiredRights.some(rightArray => {
							// console.log('rightArray:')
							// console.log(rightArray)
							return rightArray.every(right => {
								// console.log(' right: ' + right + ' ' + this.$store.getters.userHasRight(right))
								return  this.$store.getters.userHasRight(right)
							})
						})

						// console.log(route.meta.name)
						// console.log('youMayPass', youMayPass)

						if (youMayPass) {
							if (route.children) {
								// console.log('  check children')
								route.children = route.children.filter(child => {

									if (!child.meta.mainMenu) return false

									else {
										return child.meta.requiredRights.some(rightArray => {
											// console.log('  child rightArray:')
											// console.log(rightArray)
											return rightArray.every(right => {
												// console.log('  child right: ' + right + ' ' + this.$store.getters.userHasRight(right))
												return  this.$store.getters.userHasRight(right)
											})
										})
									}
								})
							}
							else if (route.meta.sections) {
								// console.log('  check sections')
								route.meta.sections = route.meta.sections.filter(section => {
									// console.log(section.href, section.name)

									return section.requiredRights.some(rightArray => {
										// console.log('  section rightArray:')
										// console.log(rightArray)
										return rightArray.every(right => {
											// console.log('  section right: ' + right + ' ' + this.$store.getters.userHasRight(right))
											return  this.$store.getters.userHasRight(right)
										})
									})
								})
							}
							return route
						}
						else return null
					}
				}).filter(route => route)
				this.userMenu =  this.$router.options.routes.filter(route => {
					if (!route.meta.userMenu) return null
					else {
						return route.meta.requiredRights.some(rightArray => {
							return rightArray.every(right => {
								return  this.$store.getters.userHasRight(right)
							})
						})
					}
				})
			},
			dialogNotifyHide () {
				this.$store.dispatch('dialogNotifyHide')
			},
			dialogConfirmAccept () {
				this.$store.dispatch('dialogConfirmAccept')
			},
			dialogConfirmDeny () {
				this.$store.dispatch('dialogConfirmDeny')
			},
			sectionGroupNavigate(item) {
				// console.log(item)
				if (this.$route.path != item.path) {
					this.$router.push(item.path)
				}
			},
			sectionNavigate(path, href) {
				if (this.$route.path != path) {
					this.$router.push(path)
				}
				this.$vuetify.goTo(href)
			},
			print() {
				// console.log('print')

				let original = {
					drawer: this.drawer,
					toolbar: this.toolbar
				}

				this.drawer = false
				this.toolbar = false

				this.$nextTick()
				.then(() => {
					window.print()

					this.drawer = original.drawer
					this.toolbar = original.toolbar
				})
			}
		},
	}
</script>
